import React from "react";

const TransferHistory = () => {
  return <div>you are not reseller. to be a reseller please contact admin.</div>;
};

export default TransferHistory;
